import React, { useEffect, useState } from "react";
import BeneficiaryList from './beneficiaryList';
import { isNumber } from "../../Utils/Common";
import { Modal } from "antd";
import { toast } from 'react-toastify';
import PropagateLoader from "react-spinners/PropagateLoader";
import { POST_DMT_INSTANT_PAY_OTP_VERIFICATION } from '../../Utils/appConstants';
import { postRequest } from '../../Utils/AppApi';
import { useHistory } from "react-router-dom";
import DmtAadharVerify from '../dmtAadharVerify';
import moment from "moment";
import { DMT_OPERATOR_CONFIGS, DMT_OPERATOR } from "../moneyTransfer/dmtOperatorConfigs";
import airtelLogo from '../../assets/airtel_payments_bank_logo.png';

// Theme colours (matching Fino / Airtel ViewCustomer)
const primaryRed = '#C9262C';
const primaryOrange = '#FF8C00';
const primaryGreen = '#02A650';
const cardBorder = '#E5E7EB';

function ViewCustomer(props) {
    const history = useHistory();
    const [customerData, setCustomerData] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const [isOtpModal, setOtpModal] = useState(false);
    const [otpCode, setOtpCode] = useState(null);
    const [getDataField, setDataField] = useState({});
    const [isAadharModal, setAadharModal] = useState(false);

    useEffect(() => {
        setCustomerData(props.isCustomerInfo);
        let lastDate = moment().subtract(19, 'years');
        let dateValue = moment(lastDate).format('YYYY-MM-DD');
        if (!props.isCustomerInfo.isVerified) {
            setDataField({ ...getDataField, ...props.isCustomerInfo, customerDob: dateValue });
        }
    }, [props.isCustomerInfo]); // eslint-disable-line react-hooks/exhaustive-deps

    const onChangeOtpValue = (value) => {
        setOtpCode(value);
    };

    const handleCustomerVerify = () => {
        console.log("========== verify");
        if (otpCode) {
            setLoading(true);
            console.log("========== otpCode", otpCode);
            const payload = {
                customerMobile: customerData.customerMobile,
                otp: otpCode,
            };

            postRequest(`${POST_DMT_INSTANT_PAY_OTP_VERIFICATION}`, payload, history)
                .then((response) => {
                    if (response.success === true) {
                        setOtpModal(false);
                        toast.success(response.message);
                    } else {
                        toast.error(response.message);
                    }
                    setLoading(false);
                })
                .catch(function (error) {
                    setOtpModal(false);
                    setLoading(false);
                });
        } else {
            toast.error("OTP code is required");
        }
    };

    if (isLoading) {
        return (
            <div className="content text-center" style={{ margin: "250px 0" }}>
                <PropagateLoader color="#5851D2" loading={isLoading} size={25} />
            </div>
        );
    }

    if (!customerData) {
        return <div className="alert alert-warning">No customer data available. Please search again.</div>;
    }

    const customerName = customerData.customerName || "Customer";
    const showPhoto = customerData && customerData.pipeInstantTransfer === "Y" && customerData.photo_link;

    return (
        <section style={{
            background: 'linear-gradient(160deg, #FFFBEB 0%, #FFF8F5 25%, #FFFBEB 50%, #F8F9FF 75%, #FFFBEB 100%)',
            padding: '10px 0 20px',
            minHeight: '100vh',
            position: 'relative',
        }}>
            <div className="container" style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 15px' }}>
                {/* Customer Header Card */}
                <div style={{
                    background: '#fff',
                    borderRadius: '20px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                    border: `1px solid ${cardBorder}`,
                    overflow: 'hidden',
                }}>
                    {/* Header row: LEFT = customer info, RIGHT = logo + photo */}
                    <div style={{
                        background: `linear-gradient(135deg, ${primaryRed} 0%, #E8454B 100%)`,
                        padding: '18px 28px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: '16px',
                    }}>
                        {/* LEFT: customer identity */}
                        <div>
                            <h3 style={{
                                margin: 0,
                                color: '#fff',
                                fontWeight: 700,
                                fontSize: '20px',
                                letterSpacing: '-0.3px',
                            }}>
                                {customerName}
                                <span style={{
                                    fontSize: '14px',
                                    fontWeight: 400,
                                    opacity: 0.8,
                                    marginLeft: '12px',
                                }}>
                                    (IPA)
                                </span>
                            </h3>
                            <div style={{
                                color: 'rgba(255,255,255,0.9)',
                                fontSize: '14px',
                                marginTop: '4px',
                            }}>
                                <i className="fas fa-mobile-alt" style={{ marginRight: '6px' }} />
                                {customerData.customerMobile}
                            </div>
                        </div>

                        {/* RIGHT: logo + photo */}
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '16px',
                        }}>
                            <img
                                src={airtelLogo}
                                alt="Airtel Logo"
                                style={{
                                    height: '70px',
                                    objectFit: 'contain',
                                }}
                            />
                            {showPhoto && (
                                <img
                                    className="elevation-2"
                                    src={"data:image/png;base64," + customerData.photo_link}
                                    alt="User Avatar"
                                    style={{
                                        width: '50px',
                                        height: '50px',
                                        borderRadius: '50%',
                                        objectFit: 'cover',
                                        border: '2px solid rgba(255,255,255,0.6)',
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </div>

                {/* Beneficiary List Section */}
                <div style={{ marginTop: '24px' }}>
                    {customerData.isVerified && (
                        <ErrorBoundary>
                            <BeneficiaryList
                                customerData={customerData}
                                findCustomerInfo={props.findCustomerInfo}
                                config={DMT_OPERATOR_CONFIGS[DMT_OPERATOR.INSTANT_PAY]}
                            />
                        </ErrorBoundary>
                    )}
                </div>

                {/* Aadhaar verify modal */}
                {isAadharModal && (
                    <DmtAadharVerify
                        serviceName={"DMT1"}
                        mobile={customerData.customerMobile}
                        aadhar={customerData.aadhar}
                        findCustomerInfo={props.findCustomerInfo}
                    />
                )}
            </div>

            {/* OTP modal */}
            {isOtpModal && (
                <Modal
                    title={"Customer Verification OTP"}
                    width={600}
                    open={isOtpModal}
                    onOk={() => handleCustomerVerify()}
                    onCancel={() => setOtpModal(false)}
                    okText={"Submit"}
                >
                    <div className="form-group">
                        <label>OTP Code</label>
                        <div className="input-group">
                            <div className="custom-file">
                                <input
                                    type="text"
                                    className="form-control"
                                    name="otpCode"
                                    placeholder="OTP Code"
                                    onChange={(e) => onChangeOtpValue(e.target.value)}
                                    autoComplete="off"
                                    value={otpCode}
                                    maxLength={6}
                                    onKeyDown={isNumber}
                                />
                            </div>
                        </div>
                    </div>
                </Modal>
            )}
        </section>
    );
}

class ErrorBoundary extends React.Component {
    state = { error: null };

    static getDerivedStateFromError(error) {
        return { error };
    }

    render() {
        if (this.state.error) {
            return (
                <div style={{
                    background: '#fff',
                    borderRadius: '20px',
                    padding: '30px',
                    textAlign: 'center',
                    border: `1px solid ${cardBorder}`,
                    boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                }}>
                    <div style={{ color: '#EF4444', fontSize: '48px', marginBottom: '12px' }}>
                        <i className="fa fa-exclamation-triangle" />
                    </div>
                    <h5 style={{ color: '#1A1A2E', fontWeight: 600 }}>Oops! Something went wrong</h5>
                    <p style={{ color: '#6B7280' }}>{this.state.error.message}</p>
                    <button
                        className="btn btn-sm"
                        onClick={() => this.setState({ error: null })}
                        style={{
                            background: primaryRed,
                            color: '#fff',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '8px 24px',
                            fontWeight: 600,
                        }}
                    >
                        Retry
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ViewCustomer;